import { Component, OnInit } from '@angular/core';
import { InvoicePeerService } from '../../service/invoice-peer.service';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { InvoicePaymentStatus } from '../../model/invoice';
import { combineLatest, Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { Invoice } from 'src/app/api/models';
import { InvoicesService } from 'src/app/api/services';
import { InvoiceCalculatorService, InvoicesAndSummary } from 'src/app/service/invoice-calculator/invoice-calculator.service';
import { MoneyPipe } from 'src/app/pipe/money.pipe';
import { Money } from 'src/app/model/money';
import { InvoiceNotificationsService } from 'src/app/service/invoice-notifications.service';
import { ClientPeerService } from 'src/app/service/client-peer.service';

// This widget is for CompanyClient. A new widget will be needed for LightEntrepreneurs.
@Component({
  selector: 'app-invoice-client-invoices-widget',
  templateUrl: './invoice-client-invoices-widget.component.html',
  styleUrls: ['./invoice-client-invoices-widget.component.scss']
})
export class InvoiceClientInvoicesWidgetComponent implements OnInit {

  data$: Observable<InvoicesAndSummary>;
  creditLimitLeft$: Observable<Money>;

  subtitle: string;

  showInvoices = false;

  constructor(
    private invoicePeerService: InvoicePeerService,
    private clientPeerService: ClientPeerService,
    private invoicesService: InvoicesService,
    private moneyPipe: MoneyPipe,
    private invoiceCalculatorService: InvoiceCalculatorService,
    private invoiceNotificationsService: InvoiceNotificationsService,
    private router: Router
  ) {
  }

  toggleInvoices(): void {
    this.showInvoices = !this.showInvoices;
  }

  showInvoice(invoiceId: number): void {
    this.router.navigateByUrl('invoices/' + invoiceId);
  }

  getPaymentStatus(invoice: Invoice): InvoicePaymentStatus {
    return this.invoiceCalculatorService.getPaymentStatus(invoice);
  }

  getTotalOpen(invoice: Invoice): Money {
    const m = new Money(this.invoiceCalculatorService.getTotalOpen(invoice));
    if (m.toDinero().getAmount() == 0) {
      return null;
    }
    return m;
  }

  ngOnInit() {

    this.data$ = this.invoicePeerService
      .getInvoice()
      .pipe(
        switchMap((invoice: Invoice) => {
          if (invoice && invoice.client_id !== null) {
            return this.invoicesService.getClientInvoices({ client_id: invoice.client_id })
              .pipe(
                map(page => {
                  return page.items;
                }),
                shareReplay(1));
          } else {
            return of([]);
          }
        }),
        map((invoices: Invoice[]) => {
          const d = this.invoiceCalculatorService.getInvoicesAndSummary(invoices);

          this.subtitle = this.moneyPipe.transform(d.open.amount, 'symbol', '1.2-2');
          if (d.overdue.count > 0) {
            this.subtitle += "⚠️";
            this.invoiceNotificationsService.setClientOverdue(true);
          }

          return d;
        })
      );

      // TODO FIXME kludge
    this.creditLimitLeft$ = combineLatest([this.data$, this.clientPeerService.get()])
      .pipe(
        //takeUntil(this.ngDestroy$))
        map(([data, client]) => {
          if (!client.credit_limit?.limit) {
            return new Money(null);
          }
          const left = new Money(new Money(client.credit_limit.limit).toDinero().subtract(data.open.amount.toDinero()));
          if (left.toDinero().isNegative()) {
            this.invoiceNotificationsService.setClientOverCreditLimit(true);
          }

          return left;
        })
      );
  }
}
